import axios from 'axios';

// Development
//const instance = axios.create({ baseURL: 'http://localhost:8000' });

// Production
const instance = axios.create({ baseURL: 'https://apihostbill.cloudhost.cm' });

export default instance;
